// import React from 'react';
// import Pagination from '../../Pagination';
// import Post from '../../Post';
// import Spacing from '../../Spacing';

// export default function BlogSectionStyle2({ data }) {
//   return (
//     <div className="container">
//       <div className="row cs_row_gap_50">
//         {data?.map((item, index) => (
//           <div className="col-xl-4 col-md-6" key={index}>
//             <Post {...item} />
//           </div>
//         ))}
//       </div>
//       <Spacing md="110" lg="70" />
//       <Pagination />
//     </div>
//   );
// }
import React, { useState, useEffect } from 'react';
import Pagination from '../../Pagination';
import Post from '../../Post';
import Spacing from '../../Spacing';
import { useSearchParams } from 'react-router-dom'; // or `next/router` for Next.js

export default function BlogSectionStyle2({ data }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromUrl = parseInt(searchParams.get('page')) || 1;

  const [currentPage, setCurrentPage] = useState(pageFromUrl);
  const postsPerPage = 6;

  useEffect(() => {
    setCurrentPage(pageFromUrl);
  }, [pageFromUrl]);

  const totalPages = Math.ceil(data.length / postsPerPage);

  const currentPosts = data.slice(
    (currentPage - 1) * postsPerPage,
    currentPage * postsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setSearchParams({ page: pageNumber });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="container">
      <div className="row cs_row_gap_50">
        {currentPosts.map((item) => (
          <div className="col-xl-4 col-md-6" key={item.id}>
            <Post {...item} />
          </div>
        ))}
      </div>
      <Spacing md="110" lg="70" />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
}
